import React from 'react';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import { Container, Msg } from './styles/NotFoundSearchMsg.styled';

export default function NotFoundSearchMsg({dir}) {
  const { translations } = React.useContext(DWTCContext);
  return (
    <Container>
      <Msg dir={dir}>
        {`${getTranslationByKey(translations, 'Your search did not return any results')}.`}
        </Msg>
    </Container>
  );
}
